"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var ProjectedMembershipRevenuesStatusEnum;
(function (ProjectedMembershipRevenuesStatusEnum) {
    ProjectedMembershipRevenuesStatusEnum["Active"] = "active";
    ProjectedMembershipRevenuesStatusEnum["NeedsDdMandate"] = "needs_dd_mandate";
    ProjectedMembershipRevenuesStatusEnum["NeedsAttention"] = "needs_attention";
    ProjectedMembershipRevenuesStatusEnum["Reserved"] = "reserved";
    ProjectedMembershipRevenuesStatusEnum["Inactive"] = "inactive";
    ProjectedMembershipRevenuesStatusEnum["Expired"] = "expired";
    ProjectedMembershipRevenuesStatusEnum["Upcoming"] = "upcoming";
})(ProjectedMembershipRevenuesStatusEnum = exports.ProjectedMembershipRevenuesStatusEnum || (exports.ProjectedMembershipRevenuesStatusEnum = {}));
function ProjectedMembershipRevenuesFromJSON(json) {
    return ProjectedMembershipRevenuesFromJSONTyped(json, false);
}
exports.ProjectedMembershipRevenuesFromJSON = ProjectedMembershipRevenuesFromJSON;
function ProjectedMembershipRevenuesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'membership_number': json['membership_number'],
        'lead_member': _1.LeadMemberSummaryFromJSON(json['lead_member']),
        'start_date': json['start_date'],
        'end_date': json['end_date'],
        'membership_type': _1.MembershipTypeSummaryFromJSON(json['membership_type']),
        'membership_rate': _1.MembershipRateSummaryFromJSON(json['membership_rate']),
        'status': json['status'],
        'gross_amount': json['gross_amount'],
        'net_amount': json['net_amount'],
        'duration_days': json['duration_days'],
        'elapsed_days': json['elapsed_days'],
        'remaining_days': json['remaining_days'],
        'gross_remaining_balance': json['gross_remaining_balance'],
        'net_remaining_balance': json['net_remaining_balance'],
    };
}
exports.ProjectedMembershipRevenuesFromJSONTyped = ProjectedMembershipRevenuesFromJSONTyped;
function ProjectedMembershipRevenuesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'membership_number': value.membership_number,
        'lead_member': _1.LeadMemberSummaryToJSON(value.lead_member),
        'start_date': value.start_date,
        'end_date': value.end_date,
        'membership_type': _1.MembershipTypeSummaryToJSON(value.membership_type),
        'membership_rate': _1.MembershipRateSummaryToJSON(value.membership_rate),
        'status': value.status,
        'gross_amount': value.gross_amount,
        'net_amount': value.net_amount,
        'duration_days': value.duration_days,
        'elapsed_days': value.elapsed_days,
        'remaining_days': value.remaining_days,
        'gross_remaining_balance': value.gross_remaining_balance,
        'net_remaining_balance': value.net_remaining_balance,
    };
}
exports.ProjectedMembershipRevenuesToJSON = ProjectedMembershipRevenuesToJSON;
